interface SelectableOption {
  id?: string;
}

interface StageOption extends SelectableOption {
  venue: string;
}

interface VenueStageSelection {
  venue: string;
  stage: string;
}

/** Keep a valid choice; choose automatically only when there is one option. */
export const getSelectedOptionId = (
  options: readonly SelectableOption[],
  selectedId: string = '',
): string => {
  if (selectedId && options.some((option) => option.id === selectedId)) return selectedId;
  return options.length === 1 ? options[0].id || '' : '';
};

/** Resolve stage defaults within the selected venue, never across other venues. */
export const getVenueStageSelection = (
  venues: readonly SelectableOption[],
  stages: readonly StageOption[],
  selected: Partial<VenueStageSelection> = {},
): VenueStageSelection => {
  const explicitStage = stages.find((stage) => stage.id === selected.stage);
  const explicitVenue = venues.find((venue) => venue.id === selected.venue);
  const venue = getSelectedOptionId(venues, explicitVenue?.id || explicitStage?.venue);
  const venueStages = venue ? stages.filter((stage) => stage.venue === venue) : [];
  return { venue, stage: getSelectedOptionId(venueStages, selected.stage) };
};
